import cookie from "js-cookie";
import { message } from "antd";
import { connect } from "react-redux";
import React, { useState } from "react";

import {
  actionHideLoading,
  actionShowLoading,
  actionGetProfile,
} from "../system/actions";
import { getUserAffiliationInfo } from "../dashboard/actions";
import { TOKEN } from "../../utils/constants/constant";

import LoginModal from "./LoginModal";
import RegisterModal from "./RegisterModal";
import ForgotPasswordModal from "./ForgotPasswordModal";

const listTypeModal = {
  LOGIN_MODAL: "LOGIN_MODAL",
  REGISTER_MODAL: "REGISTER_MODAL",
  FORGOT_PASSWORD_MODAL: "FORGOT_PASSWORD_MODAL",
};

const AuthWrapper = ({
  children = null,
  typeModal = "LOGIN_MODAL",
  isScrollTop = false,
  actionHideLoading,
  actionShowLoading,
  actionGetProfile,
}) => {
  const [visibleModal, setVisibleModal] = useState("");

  const handleSelectItem = (code = "") => {
    if (code === listTypeModal.LOGIN_MODAL) {
      setVisibleModal(listTypeModal.LOGIN_MODAL);
    } else if (code === listTypeModal.REGISTER_MODAL) {
      setVisibleModal(listTypeModal.REGISTER_MODAL);
    } else if (code === listTypeModal.FORGOT_PASSWORD_MODAL) {
      setVisibleModal(listTypeModal.FORGOT_PASSWORD_MODAL);
    } else {
      setVisibleModal("");
    }
  };

  const getToken = async (loginToken) => {
    try {
      actionShowLoading();
      const { data } = await getUserAffiliationInfo({
        //eslint-disable-next-line
        ["login_token"]: `${loginToken}`,
      });
      if (data.code === 200) {
        cookie.set(TOKEN, loginToken, { expires: 182 });
        window.location.href = "/dashboard";
        actionGetProfile();
      } else {
        data?.message && message.error(data?.message);
      }
    } catch (error) {
    } finally {
      actionHideLoading();
    }
  };

  return (
    <>
      <div
        onClick={(e) => {
          if (isScrollTop) {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
          e.preventDefault();
          const urlParams = new URLSearchParams(window.location.search);
          const loginToken = urlParams.get("login_token");
          if (loginToken) {
            getToken(loginToken);
          } else {
            setVisibleModal(typeModal);
          }
        }}
      >
        {children || null}
      </div>
      <LoginModal
        visible={visibleModal === listTypeModal.LOGIN_MODAL}
        handleVisible={handleSelectItem}
      />
      <RegisterModal
        visible={visibleModal === listTypeModal.REGISTER_MODAL}
        handleVisible={handleSelectItem}
      />
      <ForgotPasswordModal
        visible={visibleModal === listTypeModal.FORGOT_PASSWORD_MODAL}
        handleVisible={handleSelectItem}
      />
    </>
  );
};

export default connect(() => ({}), {
  actionHideLoading,
  actionShowLoading,
  actionGetProfile,
})(AuthWrapper);
